<template>
    <div class="person-managing">
        <mc-operate-bar>
            <template slot="left">
                <mc-search-bar v-model="searchParmas" search-label="输入姓名/联系电话/标签" :search-submit="$_getTableList">
                </mc-search-bar>
            </template>
            <template slot="right">
                <el-button type="primary" @click="dialog.person.methods.open()">新增人员</el-button>
            </template>
        </mc-operate-bar>
        <mc-table ref="mc-table" :table-option="tableOption" v-loading="tableOption.loading">
            <template slot="table-components">
                <el-table-column sortable :prop="tableOption.head[0].prop" :label="tableOption.head[0].label"
                    :width="tableOption.head[0].width" v-if="tableOption.head.length>0"></el-table-column>
                <el-table-column :prop="tableOption.head[1].prop" :label="tableOption.head[1].label"
                    :width="tableOption.head[1].width" v-if="tableOption.head.length>0"></el-table-column>
                <el-table-column :prop="tableOption.head[2].prop" :label="tableOption.head[2].label"
                    :width="tableOption.head[3].width" v-if="tableOption.head.length>0"></el-table-column>
                <el-table-column sortable :prop="tableOption.head[3].prop" :label="tableOption.head[3].label"
                    :width="tableOption.head[3].width" v-if="tableOption.head.length>0"></el-table-column>
                <el-table-column sortable :prop="tableOption.head[4].prop" :label="tableOption.head[4].label"
                    :width="tableOption.head[4].width" v-if="tableOption.head.length>0">
                    <template slot-scope="scope">
                        {{$_handleTime(scope.row.create_at)}}
                    </template>
                </el-table-column>
            </template>
        </mc-table>
        <mc-pager :pager-option.sync="pager" ref="person-managing-pager" @getList="$_getTableList"></mc-pager>

        <mc-dialog :dialog-option.sync="dialog.person">
            <template slot="content">
                <mc-layout-row label-text="账号（邮箱）" :labelWidth="150" important style="word-wrap:break-word;">
                    <el-input v-if="!this.dialog.person.data.row" style="width:100%"
                        v-model="dialog.person.data.newPerson.email" placeholder="请输入">
                    </el-input>
                    <mc-label v-else info>{{dialog.person.data.row.email}}</mc-label>
                    <!-- <el-input v-if="this.dialog.person.data.row" style="width:100%" disabled="" v-model="dialog.person.data.row.email"></el-input> -->
                </mc-layout-row>

                <mc-layout-row label-text="姓名" :labelWidth="150" important>
                    <el-input style="width:100%" placeholder="请输入" v-model="dialog.person.data.newPerson.username">
                    </el-input>
                </mc-layout-row>

                <mc-layout-row label-text="手机号码" :labelWidth="150" important>
                    <el-input style="width:100%" placeholder="请输入" v-model="dialog.person.data.newPerson.mobile">
                    </el-input>
                </mc-layout-row>

                <mc-layout-row label-text="标签" :labelWidth="150">
                    <el-input style="width:100%" placeholder="请输入" v-model="dialog.person.data.newPerson.tag">
                    </el-input>
                </mc-layout-row>

            </template>
        </mc-dialog>

        <mc-dialog :dialog-option.sync="dialog.delete">
            <template slot="content">
                <mc-label icon="el-icon-error" error>删除后不可恢复，确定删除这个人员吗？</mc-label>
            </template>
        </mc-dialog>

        <mc-dialog :dialog-option.sync="dialog.reset">
            <template slot="content">
                <mc-label icon="el-icon-warning" warn>重置密码将以邮件形式发送，确定重置该人员密码吗？</mc-label>
            </template>
        </mc-dialog>

    </div>
</template>

<script>
    export default {
        name: "person-managing",
        data() {
            return {
                searchParmas: '',
                pager: {
                    page: 1,
                    per_page: 10,
                    per_pages: [10, 20, 30, 40, 50],
                    total: 0,
                },
                tableOption: {
                    loading: false,
                    index: {
                        disable: true,
                    },
                    operations: {
                        disable: true,
                        label: "操作",
                        items: [{
                                label: "修改",
                                type: "primary",
                                size: "mini",
                                click: (index, row) => {
                                    this.dialog.person.methods.open(row);
                                }
                            }, {
                                label: "删除",
                                type: "danger",
                                size: "mini",
                                click: (index, row) => {
                                    this.dialog.delete.methods.open(row);
                                }
                            },
                            {
                                label: "密码",
                                type: "warning",
                                size: "mini",
                                click: (index, row) => {
                                    this.dialog.reset.methods.open(row);
                                }
                            }
                        ]
                    },
                    head: [{
                            prop: "username",
                            label: "姓名",
                            width: "160",
                        },
                        {
                            prop: "email",
                            label: "账号",
                            width: "",
                        },
                        {
                            prop: "mobile",
                            label: "联系电话",
                            width: "",
                        },
                        {
                            prop: "tag",
                            label: "标签",
                            width: "",
                        },
                        {
                            prop: "create_at",
                            label: "创建时间",
                            width: "",
                        },
                    ],
                    data: [],
                },
                dialog: {
                    person: {
                        visible: false,
                        title: "新增人员",
                        style: {
                            showConfirm: true,
                        },
                        methods: {
                            open: (item) => {
                                if (item) {
                                    this.dialog.person.title = '修改人员'
                                    this.dialog.person.data.row = item;
                                } else {
                                    this.dialog.person.title = '新增人员'
                                    this.dialog.person.data.row = null
                                }
                                if (this.dialog.person.data.row) {
                                    this.dialog.person.data.newPerson = {
                                        email: this.dialog.person.data.row.email,
                                        mobile: this.dialog.person.data.row.mobile,
                                        username: this.dialog.person.data.row.username,
                                        tag: this.dialog.person.data.row.tag
                                    }
                                } else {
                                    this.dialog.person.data.newPerson = {
                                        email: '',
                                        mobile: '',
                                        username: '',
                                        tag: ''
                                    }
                                }
                                this.dialog.person.visible = true;
                            },
                            confirm: () => {
                                if (!this.dialog.person.data.row) {
                                    this.$_newPerson();
                                } else {
                                    this.$_editorerson();
                                }
                            }
                        },
                        data: {
                            row: {},
                            newPerson: {
                                email: '',
                                mobile: '',
                                username: '',
                                tag: ''
                            },
                        },
                    },
                    reset: {
                        visible: false,
                        title: "重置密码",
                        style: {
                            showConfirm: true,
                            width: '400px'
                        },
                        methods: {
                            open: (item) => {
                                this.dialog.reset.data.row = item
                                this.dialog.reset.visible = true;
                            },
                            confirm: () => {
                                this.$_resetPassword(this.dialog.reset.data.row.id)
                            }
                        },
                        data: {
                            row: {},
                        },
                    },
                    delete: {
                        visible: false,
                        title: "删除人员",
                        style: {
                            showConfirm: true,
                            width: '400px'
                        },
                        methods: {
                            open: (item) => {
                                this.dialog.delete.data.row = item
                                this.dialog.delete.visible = true;
                            },
                            confirm: () => {
                                this.$_deletePerson(this.dialog.delete.data.row.id)
                            }
                        },
                        data: {
                            row: {},
                        },
                    }
                },
            }
        },
        mounted() {
            this.$_getTableList();
        },
        methods: {
            $_getTableList: async function () {
                this.tableOption.loading = true;
                let params = {
                    username: this.searchParmas,
                    page: this.pager.page,
                    per_page: this.pager.per_page
                }
                let data = await this.$api.adminPersonManaging.getList.getPendList.call(this, params);
                if (data !== false) {
                    this.pager.total = data.total;
                    this.tableOption.data = data.items;
                }
                this.tableOption.loading = false;
            },
            $_newPerson: async function () {
                let reg = new RegExp(/^([a-zA-Z0-9._-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-]+){1,2}$/);
                let tel_reg = new RegExp(/1\d{10}/)
                let params = this.dialog.person.data.newPerson;
                if (params.email == '') {
                    this.$message.warning("请填写账号.");
                    return
                }
                if (params.username == '') {
                    this.$message.warning("请填写姓名.");
                    return
                }
                if (params.mobile == '') {
                    this.$message.warning("请填写手机号码.");
                    return
                }
                if (reg.test(params.email) == false) {
                    this.$message.warning("登陆账号格式错误，请填写邮件格式.");
                    return
                }
                if (tel_reg.test(params.mobile) == false) {
                    this.$message.warning("手机号码格式错误，请填写正确的手机号码.");
                    return
                }
                let data = await this.$api.adminPersonManaging.do.newPerson.call(this, params);
                if (data !== false) {
                    this.$_getTableList();
                    this.dialog.person.visible = false;
                    this.$message.success("添加成功.");
                }
            },
            $_editorerson: async function () {
                let reg = new RegExp(/^([a-zA-Z0-9._-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-]+){1,2}$/);
                let tel_reg = new RegExp(/1\d{10}/)
                if (this.dialog.person.data.newPerson.email == '') {
                    this.$message.warning("请填写账号.");
                    return
                }
                if (this.dialog.person.data.newPerson.username == '') {
                    this.$message.warning("请填写姓名.");
                    return
                }
                if (this.dialog.person.data.newPerson.mobile == '') {
                    this.$message.warning("请填写手机号码.");
                    return
                }
                if (reg.test(this.dialog.person.data.newPerson.email) == false) {
                    this.$message.warning("登陆账号格式错误，请填写邮件格式.");
                    return
                }
                if (tel_reg.test(this.dialog.person.data.newPerson.mobile) == false) {
                    this.$message.warning("手机号码格式错误，请填写正确的手机号码.");
                    return
                }
                let params = {
                    new_email: this.dialog.person.data.newPerson.email,
                    mobile: this.dialog.person.data.newPerson.mobile,
                    username: this.dialog.person.data.newPerson.username,
                    id: this.dialog.person.data.row.id,
                    tag: this.dialog.person.data.newPerson.tag,
                };
                let data = await this.$api.adminPersonManaging.do.editorPerson.call(this, params);
                if (data !== false) {
                    this.$_getTableList();
                    this.dialog.person.visible = false;
                    this.$message.success("修改成功.");
                }
            },
            $_deletePerson: async function (item) {
                let params = {
                    id: item,
                }
                let data = await this.$api.adminPersonManaging.do.deletePerson.call(this, params);
                if (data !== false) {
                    this.dialog.delete.visible = false;
                    this.$_getTableList();
                    this.$message.success("删除成功.");
                }
            },
            $_resetPassword: async function (item) {
                let params = {
                    id: item,
                }
                let data = await this.$api.adminPersonManaging.getList.resetPassword.call(this, params);
                if (data !== false) {
                    this.dialog.reset.visible = false;
                    this.$_getTableList();
                    this.$message.success("邮件已发送.");
                }
            },
            $_handleTime(time) {
                let origindate = Date.parse(time);
                let date = new Date(origindate + 8 * 60 * 60 * 1000)
                let Y = date.getFullYear() + '-';
                let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
                let D = date.getDate() + ' ';
                let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
                let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
                let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
                return Y + M + D + h + m + s
            }
        },
        watch: {
            pager: {
                deep: true,
                handler: function () {
                    this.$_getTableList();
                },
            },
        }
    }
</script>

<style lang="less">
    .person-managing {
        width: 100%;

        .el-dialog {
            .require {
                color: red
            }

            .site-item {
                display: inline-flex;
                align-items: center;
                width: 100%;
                margin-bottom: 20px;

                label {
                    width: 120px;
                    text-align: right;
                }

                .site-input {
                    flex: 1;
                    padding-left: 10px;
                }
            }
        }

        .mc-row-item-label {
            padding-right: 10px !important;
        }
    }
</style>